import { query } from "../../erd-editor-schema/dist/query/index.js";
import { isMemoShown } from "../../utils/memo.js";
import { getVisibleIds } from "./viewLayout.js";
import { getMemoRect, getTableRect, unionRect } from "./metrics.js";
import { growTableGroupBox, isTableGroupShown, seedTableGroupBoxes } from "../../utils/tableGroup.js";
//#region src/konva/scene/contentBounds.ts
function getContentRect(state) {
	return getContentRectAfter(state, []);
}
function hasContent(state) {
	const { doc } = state;
	return doc.tableIds.length > 0 || doc.memoIds.length > 0 && isMemoShown(state) || doc.tableGroupIds.length > 0 && isTableGroupShown(state);
}
function getSceneContentRect(state, source = "document") {
	return getContentRectAfter(state, [], source);
}
function getContentRects(state, moves = [], source = "document", groupRects = []) {
	const { collections, doc } = state;
	const { tableIds, memoIds, tableGroupIds } = source === "document" ? doc : getVisibleIds(state, source);
	const shownMemoIds = isMemoShown(state) ? memoIds : [];
	const moved = new Map(moves.map((move) => [move.id, move]));
	const groups = tableGroupIds.length && isTableGroupShown(state) ? query(collections).collection("tableGroupEntities").selectByIds(tableGroupIds) : [];
	const groupBoxes = seedTableGroupBoxes(groups);
	const placedGroups = new Map(groupRects.map(({ id, ...rect }) => [id, rect]));
	const tables = query(collections).collection("tableEntities").selectByIds(tableIds);
	const memos = query(collections).collection("memoEntities").selectByIds(shownMemoIds);
	return [
		...tables.map((table) => {
			const rect = getTableRect(state, table, source);
			const move = moved.get(table.id);
			if (move) return {
				...rect,
				x: move.x,
				y: move.y
			};
			growTableGroupBox(groupBoxes, table, rect);
			return rect;
		}),
		...memos.map(getMemoRect),
		...groups.map((group) => placedGroups.get(group.id) ?? groupBoxes.get(group.id))
	];
}
function getContentRectAfter(state, moves, source = "document", groupRects = []) {
	const boxes = getContentRects(state, moves, source, groupRects);
	return boxes.length ? boxes.reduce(unionRect) : null;
}
//#endregion
export { getContentRect, getContentRectAfter, getContentRects, getSceneContentRect, hasContent, unionRect };
